import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHandling } from './useAuthhandling';

import Config from "./Config";
import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Deletemodal from "./Deletemodal";
import Nodatafound from "./Nodatafound";

function Contactrequest() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [clientdata, setClientdata] = useState([]);
  const [pagenum,setPagenum]=useState(1);
  const [paginate,setPaginate]=useState("");
  const[pageindex,setPageindex]=useState(1);
  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }
  
  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/contact-requests?page=1`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {
      const data = await res.json();

      setClientdata(data.data[0].data);
      setPaginate(data.data[0].total_pages);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
    


    }
  };
  useEffect(() => {
    getinfo();
  }, []);

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/delete-contact/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );

    if (response.status === 200) {
      const deletedata = await response.json();
      toast.success("Sucessfully deleted", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handlePageClick(pagenum);
    } 
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData(id);
    }
    else {
    
    }
  };

  const fetchComments = async (currentPage) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/contact-requests?page=${currentPage}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
     if(res.status === 200){
    
    const data = await res.json();
    return data.data[0].data;
  }
  else if(res.status === 401){
    handleUnauthorized();
    fetchComments(currentPage);
  }
  };

  const handlePageClick = async (data) => {
    if(data===1){
        setPageindex(1);
      setPagenum(data);
      const commentsFormServer = await fetchComments(data);
      setClientdata(commentsFormServer);
    }
    else{
    let currentPage = data.selected + 1;
    setPagenum(data);
    setPageindex(currentPage);
    const commentsFormServer = await fetchComments(currentPage);

    setClientdata(commentsFormServer);
    }
    
  };
  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Contact Requests</h4>
                    <div className="table-responsive pt-3">
                    {clientdata?.length>0?
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sl.No</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Contact Number</th>
                            <th>Status</th>
                            {/* <th>Action</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {clientdata.map((element, i) => {
                            return (
                              <>
                                <tr>
                                <td scope="row">{pageindex===1 ? i + 1: (pageindex-1) * 10 + i + 1}</td>
                                  <td>{element.userName}</td>
                                  <td>{element.userEmail}</td>
                                  <td>{element.contactNumber}</td>
                                  <td style={{textTransform:"capitalize"}}>{element.status}</td>
                                  {/* <td className="actions_td">
                                    <Link
                                      onClick={() => tog_animationFlip(element._id)}
                                    >
                                      <i className="fa-solid fa-trash action_icons" />
                                    </Link>
                                    <Link
                                        to={"/contactview/" + element._id}
                                        className=" action_icons"                                       
                                      >
                                          <i className="fa-solid fa-eye" />
                                        </Link>
                                    <ToastContainer />
                                  </td> */}
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                      :
                      <Nodatafound/>
                    }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {paginate > 1 ? (
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={paginate}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              ) : (
                ""
              )}
          </div>
        </div>
      </div>
      {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Contact"}
          />
        ) : (
          ""
        )}
    </div>
  );
}

export default Contactrequest;
